/** @format */

'use client';
import { useAxios } from '@/hooks';
import { endPoint } from '@/utils';
import React, { useEffect } from 'react';
import { CategoryBannerCard, CategoryBannerSkeleton } from './components';

const CategoryBanner = ({ categoryCode }: { categoryCode: string }) => {
  const { fetchData, loading, response } = useAxios(true);
  const data = response?.data?.[0];
  const handleCategory = async () => {
    await fetchData({
      url: endPoint.FETCH_CATEGORY_INFO,
      method: 'POST',
      data: { categoryCode },
    });
  };
  useEffect(() => {
    handleCategory();
  }, []);
  
  return loading ? (
    <CategoryBannerSkeleton />
  ) : (
    <CategoryBannerCard data={data} />
  );
};

export default CategoryBanner;
